import styles from './PositionInfoDialog.module.scss';

import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PositionConversionHistory } from '@work4all/models/lib/Classes/PositionConversionHistory.entity';
import { BzObjType } from '@work4all/models/lib/Enums/BzObjType.enum';

import { PositionInfoTableRows } from './PositionInfoTableRows';

interface PositionInfoDialogProps {
  positionConversionHistoryList: PositionConversionHistory[];
}

export const PositionInfoDialog = (props: PositionInfoDialogProps) => {
  const { positionConversionHistoryList } = props;

  const { t } = useTranslation();

  const groupByBzObjType = useMemo(() => {
    return positionConversionHistoryList.reduce((acc, item) => {
      acc[item.originalBzObjType] = [
        ...(acc[item.originalBzObjType] || []),
        item,
      ];
      return acc;
    }, {} as Record<BzObjType, PositionConversionHistory[]>);
  }, [positionConversionHistoryList]);

  return (
    <Stack style={{ backgroundColor: 'var(--ui03)' }}>
      <table className={styles.table} cellPadding={0} cellSpacing={0}>
        <thead>
          <tr>
            <th>{t('COMMON.SOURCE')}</th>
            <th>{t('COMMON.BUSINESSPARTNER')}</th>
            <th>{t('COMMON.POSITION_NUMBER')}</th>
            <th>{t('COMMON.DESCRIPTION')}</th>
            <th className={styles.right}>{t('COMMON.ERP.AMOUNT')}</th>
            <th>{t('COMMON.UNIT')}</th>
            <th className={styles.right}>{t('COMMON.ERP.PURCHASE_PRICE')}</th>
            <th className={styles.right}>{t('COMMON.ERP.SELLING_PRICE')}</th>
            <th>{t('COMMON.PROJECT')}</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(groupByBzObjType).map(
            ([bzObjType, positionConversionHistoryList]) => {
              return (
                <PositionInfoTableRows
                  positionConversionHistoryList={positionConversionHistoryList}
                  bzObjType={bzObjType as BzObjType}
                  key={bzObjType}
                />
              );
            }
          )}
        </tbody>
      </table>
    </Stack>
  );
};
